import { render } from "./FacebookActivity.vue?vue&type=template&id=6d20dcec&scoped=true"
import script from "./FacebookActivity.vue?vue&type=script&lang=js"
export * from "./FacebookActivity.vue?vue&type=script&lang=js"

import "./FacebookActivity.vue?vue&type=style&index=0&id=6d20dcec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d20dcec"]])

export default __exports__